import React from "react";
import styled from "styled-components";
import OpenIdeaLinkBox from "../../idea/OpenIdeaLinkBox";
import howLongAgo from "../../../util/timeDescription";
import {ellipsis} from "../../../style/styleConsts";

const OpenTime = styled.div`
    width: 55px;
`;

const AuthorName = styled.div`
    margin-left: 10px;
    width: 190px;
`;

export const OpenIdeaRow = ({idea, showDetail}) => (
    <OpenIdeaLinkBox onClick={() => showDetail(idea.ideaId)}>
        <OpenTime className="date">{howLongAgo(idea.openTimestamp)}</OpenTime>
        <AuthorName className="t-author">
            <div style={ellipsis}>{idea.author}</div>
        </AuthorName>
    </OpenIdeaLinkBox>
);